import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { Globe } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function LanguageSwitcher() {
  const { lang, changeLang, languages } = useLang();
  const foreign = languages.filter((l) => l.region !== "India");
  const indian = languages.filter((l) => l.region === "India");
  const current = languages.find((l) => l.code === lang);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="lang-switcher-trigger"
        className="btn-sharp inline-flex items-center gap-1.5 border border-border bg-card hover:bg-muted px-2 py-1 text-[10px] uppercase tracking-wider"
      >
        <Globe className="h-3 w-3 text-primary" />
        <span className="mono">{current?.label || "EN"}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56 max-h-80 overflow-auto" data-testid="lang-menu">
        <DropdownMenuLabel className="text-[10px] uppercase tracking-widest text-muted-foreground">Foreign</DropdownMenuLabel>
        {foreign.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-opt-${l.code}`}
            onClick={() => changeLang(l.code)}
            className={l.code === lang ? "bg-muted" : ""}
          >
            <span className="mono w-8 text-xs">{l.code}</span> <span>{l.label}</span>
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuLabel className="text-[10px] uppercase tracking-widest text-muted-foreground">India (State-wise)</DropdownMenuLabel>
        {indian.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-opt-${l.code}`}
            onClick={() => changeLang(l.code)}
            className={l.code === lang ? "bg-muted" : ""}
          >
            <span className="mono w-8 text-xs">{l.code}</span> <span>{l.label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
